import React from 'react';
import Section from '../Section';
import { NOTES } from '../content';
import styles from './InfoPanel.module.css';

export default function Notes() {
  return (
    <Section id="notes" title="注意事項" eyebrow="NOTES">
      <ul className={`${styles.panel} ${styles.noteList}`}>
        {NOTES.map((note, index) => (
          <li key={index} className={styles.noteItem}>
            {note}
          </li>
        ))}
      </ul>
    </Section>
  );
}
